import cdnAssetsList from '@/assets/cdn/.file-list.json?raw';

export const AssetPlugin = {
  install(Vue) {
    Vue.prototype.$log('AssetPlugin', 'init start');

    const environmentDomainPrefix = {
      sandbox: 'sandbox.',
      staging: 'staging.',
      production: ''
    };

    const imageAssets = import.meta.glob('@/assets/**/*.{svg,png,jpg,jpeg,webp}', {
      eager: true,
      query: '?url',
      import: 'default'
    });

    const lottieAnimationJsonStrings = import.meta.glob('@/assets/animations/**/*.json', {
      eager: true,
      query: '?raw',
      import: 'default'
    });

    // convert JSON strings to objects
    const lottieAnimationAssets = Object.fromEntries(
      Object.entries(lottieAnimationJsonStrings).map(([key, jsonData]) => {
        return [key, JSON.parse(`${jsonData}`)];
      })
    );

    const cdnAssets = JSON.parse(cdnAssetsList).reduce((acc, asset) => {
      const devModePath = `src/assets/cdn/${asset}`;
      // const devModePath = `https://cdn.sandbox.ulekare.cz/${asset}`;

      return {
        ...acc,
        [asset]:
          import.meta.env.MODE === 'development'
            ? devModePath
            : `https://cdn.${environmentDomainPrefix[import.meta.env.MODE]}ulekare.cz/${asset}`
      };
    }, {});

    const rawAssets = {
      ...imageAssets,
      ...lottieAnimationAssets,
      ...cdnAssets
    };

    const assets = Object.fromEntries(
      Object.entries(rawAssets).map(([fullPath, url]) => {
        // fullPath is like '/src/assets/img/logo.svg'
        const key = fullPath.replace(/^\/src\/assets\//, ''); // 'img/logo.svg'
        return [key, url];
      })
    );

    Vue.prototype.$log('AssetPlugin', `preloaded ${Object.keys(assets).length} asset paths`, 'D');

    Vue.prototype.$asset = (path, type) => {
      // path must match one of the glob keys,
      // for example 'img/logo.svg'
      const url = assets[path];
      if (!url) {
        Vue.prototype.$log('AssetPlugin', `asset not found: ${path}`, 'E');
      }

      if (type === 'raw') {
        return url;
      }

      return url || '';
    };

    Vue.prototype.$log('AssetPlugin', 'init done', 'S');
  }
};
